module.exports = __webpack_public_path__ + "static/img/logo_hp.d797b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_hp.png
// module id = yfGG
// module chunks = 6